// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N24bo1XLXSyBAYdb0UoX {
  background: #f7f8f9;
  height: 100%;
}
.uBobYDRHU9WKMeNPgzMM {
  background: #ffffff;
  box-shadow: 0 6px 58px 0 rgba(196, 203, 214, 0.1);
  border-radius: 2px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Organizations/List/index.module.less"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,YAAA;AAAF;AAGA;EACE,mBAAA;EACA,iDAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADF","sourcesContent":["\n.container {\n  background: #f7f8f9;\n  height: 100%;\n}\n\n.listItem {\n  background: #ffffff;\n  box-shadow: 0 6px 58px 0 rgba(196, 203, 214, 0.1);\n  border-radius: 2px;\n  padding: 16px;\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `N24bo1XLXSyBAYdb0UoX`,
	"listItem": `uBobYDRHU9WKMeNPgzMM`
};
export default ___CSS_LOADER_EXPORT___;
